/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable import-helpers/order-imports */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable react/forbid-prop-types */

import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  PopoverBody,
  PopoverHeader,
  Row,
  Table,
  UncontrolledPopover,
  UncontrolledTooltip,
} from 'reactstrap';
import { NumericFormat } from 'react-number-format';
import Pagination from '../Pagination';

import './styles.css';

function getColumnId(column, index) {
  const raw = column.id || column.dataField || `col-${index}`;
  return `column-${String(raw).replace(/\./g, '-')}-${index}`;
}

const FILTER_DEBOUNCE_MS = 400;

const CustomTable = forwardRef(function CustomTable({
  columns = [],
  data = [],
  page = 1,
  limit = 10,
  totalDocs = 0,
  totalPages = 0,
  loading = false,
  hasPrevPage = false,
  hasNextPage = false,
  paging = true,
  onChangePage = () => null,
  onRowClick = () => null,
  selectableColumns = false,
  initialSelectedColumns,
  onColumnsChange,
  onFiltersChange,
}, ref) {
  const [showSelectColumns, setShowSelectColumns] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState(() => (selectableColumns ? (initialSelectedColumns ?? columns) : columns));
  const [searchArray, setSearchArray] = useState([]);
  const [textFilterDraft, setTextFilterDraft] = useState({});
  const [rangeFilterDraft, setRangeFilterDraft] = useState({});
  const debounceTimersRef = useRef({});

  const clearDebounceTimer = useCallback((key) => {
    const id = debounceTimersRef.current[key];
    if (id) clearTimeout(id);
    delete debounceTimersRef.current[key];
  }, []);

  useEffect(() => () => {
    Object.keys(debounceTimersRef.current).forEach((key) => {
      clearTimeout(debounceTimersRef.current[key]);
    });
    debounceTimersRef.current = {};
  }, []);

  const scheduleDebouncedSearch = useCallback((key, run) => {
    clearDebounceTimer(key);
    debounceTimersRef.current[key] = setTimeout(run, FILTER_DEBOUNCE_MS);
  }, [clearDebounceTimer]);

  // Mantém a seleção atual quando a lista de colunas muda (caso raro),
  // mas preserva o estado de "limpar" (selectedColumns = []).
  useEffect(() => {
    if (!selectableColumns) return;
    setSelectedColumns((prev) => {
      const alwaysVisible = columns.filter((c) => c.alwaysVisible);
      if (prev.length === 0) return alwaysVisible;
      const prevDataFields = new Set(prev.map((c) => c.dataField));
      const next = columns.filter((c) => prevDataFields.has(c.dataField) || c.alwaysVisible);
      return next.length ? next : (initialSelectedColumns ?? columns);
    });
  }, [columns, selectableColumns, initialSelectedColumns]);

  useEffect(() => {
    if (!selectableColumns) return;
    if (typeof onColumnsChange === 'function') {
      onColumnsChange(selectedColumns);
    }
  }, [selectedColumns, selectableColumns, onColumnsChange]);

  useEffect(() => {
    if (typeof onFiltersChange === 'function') {
      onFiltersChange(searchArray);
    }
  }, [searchArray, onFiltersChange]);

  useImperativeHandle(ref, () => ({
    openSelectColumns: () => setShowSelectColumns(true),
    closeSelectColumns: () => setShowSelectColumns(false),
  }), []);

  const visibleColumns = useMemo(
    () => (selectableColumns ? selectedColumns : columns),
    [selectableColumns, selectedColumns, columns],
  );

  const toggleColumn = useCallback((column) => {
    if (column?.alwaysVisible) return;
    setSelectedColumns((prev) => {
      const exists = prev.some((c) => c.dataField === column.dataField);
      if (exists) return prev.filter((c) => c.dataField !== column.dataField);
      return [...prev, column];
    });
  }, []);

  const restoreColumns = useCallback(() => {
    setSelectedColumns(columns);
  }, [columns]);

  const clearColumns = useCallback(() => {
    setSelectedColumns(columns.filter((c) => c.alwaysVisible));
  }, [columns]);

  const setSearch = useCallback((search) => {
    if (!search?.field) return;
    setSearchArray((prevState = []) => {
      const searchAdded = prevState.find((s) => s.field === search.field);
      if (searchAdded) {
        return prevState.map((s) => (s.field === search.field ? { ...s, ...search } : s));
      }
      return [...prevState, search];
    });
  }, []);

  const clearFilter = useCallback((field) => {
    clearDebounceTimer(`text:${field}`);
    setTextFilterDraft((prev) => {
      const next = { ...prev };
      delete next[field];
      return next;
    });
    setSearchArray((prevSearchArray = []) => prevSearchArray.map(
      (s) => (s.field === field ? { ...s, value: '' } : s),
    ));
  }, [clearDebounceTimer]);

  const clearRangeFilter = useCallback((field) => {
    const startKey = `start${field}`;
    const endKey = `end${field}`;
    clearDebounceTimer(`range:${startKey}`);
    clearDebounceTimer(`range:${endKey}`);
    setRangeFilterDraft((prev) => {
      const next = { ...prev };
      delete next[startKey];
      delete next[endKey];
      return next;
    });
    setSearchArray((prevSearchArray = []) => prevSearchArray.map((s) => (
      s.field === startKey
        ? { ...s, startRange: '' }
        : s.field === endKey
          ? { ...s, endRange: '' }
          : s
    )));
  }, [clearDebounceTimer]);

  const getColumnTextFilterField = useCallback((column) => (
    column.filterField || column.dataField
  ), []);

  const getColumnRangeFilterField = useCallback((column) => (
    column.rangeFilterField || column.dataField
  ), []);

  const renderHeader = useCallback(() => (
    <thead>
      <tr>
        {visibleColumns.map((column, index) => (
          <th
            key={`${column.dataField}-${index}`}
            style={{
              verticalAlign: 'top',
              width: column.width || 'auto',
              minWidth: column.minWidth || 'auto',
              maxWidth: column.maxWidth || 'none',
              whiteSpace: column.nowrap === false ? 'normal' : 'nowrap',
            }}
          >
            <UncontrolledTooltip target={`#${getColumnId(column, index)}`} fade>
              {column.text}
            </UncontrolledTooltip>
            <div id={getColumnId(column, index)} className="p-1 text-truncate">
              {column.text}
            </div>
            {column.textFilter ? (
              <Row>
                <Col>
                  <div className="d-flex">
                    <FormGroup className="w-100 mb-0">
                      <Input
                        type="text"
                        bsSize="sm"
                        placeholder={column.placeholder || `Buscar por ${column.text}`}
                        value={(() => {
                          const field = getColumnTextFilterField(column);
                          if (Object.prototype.hasOwnProperty.call(textFilterDraft, field)) {
                            return textFilterDraft[field];
                          }
                          return searchArray.find((s) => s.field === field)?.value || '';
                        })()}
                        onChange={({ target: { value } }) => {
                          const field = getColumnTextFilterField(column);
                          setTextFilterDraft((prev) => ({ ...prev, [field]: value }));
                          scheduleDebouncedSearch(`text:${field}`, () => {
                            setSearch({ field, value });
                            setTextFilterDraft((prev) => {
                              const next = { ...prev };
                              delete next[field];
                              return next;
                            });
                          });
                        }}
                      />
                    </FormGroup>
                    {(() => {
                      const field = getColumnTextFilterField(column);
                      const hasDraft = Object.prototype.hasOwnProperty.call(textFilterDraft, field)
                        && textFilterDraft[field] !== '';
                      const hasCommitted = !!searchArray.find(
                        (s) => s.field === field && s.value !== '',
                      );
                      return hasDraft || hasCommitted;
                    })() ? (
                      <Button
                        className="ml-1"
                        color="danger"
                        size="sm"
                        style={{
                          height: '2rem',
                        }}
                        onClick={() => clearFilter(getColumnTextFilterField(column))}
                      >
                        <i className="fa-solid fa-filter-circle-xmark" />
                      </Button>
                      ) : null}
                  </div>
                </Col>
              </Row>
            ) : null}
            {column.moneyRangeFilter ? (
              <Row>
                <Col>
                  <div className="d-flex">
                    <Button
                      id={`${getColumnRangeFilterField(column)}-uncontrolledPopoverMoneyRangeFilter-${index}`}
                      color="primary"
                      size="sm"
                      block
                    >
                      Filtrar
                    </Button>
                    {(() => {
                      const rf = getColumnRangeFilterField(column);
                      const startKey = `start${rf}`;
                      const endKey = `end${rf}`;
                      const hasDraftStart = Object.prototype.hasOwnProperty.call(rangeFilterDraft, startKey)
                        && rangeFilterDraft[startKey] !== '';
                      const hasDraftEnd = Object.prototype.hasOwnProperty.call(rangeFilterDraft, endKey)
                        && rangeFilterDraft[endKey] !== '';
                      const hasDraft = hasDraftStart || hasDraftEnd;
                      const hasCommitted = !!searchArray.find(
                        (s) => (s.field === startKey && s.startRange !== '' && s.startRange != null)
                          || (s.field === endKey && s.endRange !== '' && s.endRange != null),
                      );
                      return hasDraft || hasCommitted;
                    })() ? (
                      <Button
                        className="ml-1"
                        color="danger"
                        size="sm"
                        style={{
                          height: '2rem',
                        }}
                        onClick={() => clearRangeFilter(getColumnRangeFilterField(column))}
                      >
                        <i className="fa-solid fa-filter-circle-xmark" />
                      </Button>
                      ) : null}
                    <UncontrolledPopover
                      placement="bottom"
                      target={`${getColumnRangeFilterField(column)}-uncontrolledPopoverMoneyRangeFilter-${index}`}
                      trigger="legacy"
                    >
                      <PopoverHeader>
                        {`Filtro por ${column.text}`}
                      </PopoverHeader>
                      <PopoverBody>
                        <Row>
                          <Col>
                            <NumericFormat
                              customInput={Input}
                              placeholder="Digite um valor"
                              decimalSeparator=","
                              thousandSeparator="."
                              decimalScale={2}
                              prefix="R$"
                              value={(() => {
                                const startKey = `start${getColumnRangeFilterField(column)}`;
                                if (Object.prototype.hasOwnProperty.call(rangeFilterDraft, startKey)) {
                                  return rangeFilterDraft[startKey];
                                }
                                return searchArray.find((s) => s.field === startKey)?.startRange || '';
                              })()}
                              fixedDecimalScale
                              valueIsNumericString
                              onValueChange={({ floatValue }) => {
                                const rf = getColumnRangeFilterField(column);
                                const startKey = `start${rf}`;
                                const normalized = floatValue === undefined || floatValue === null ? '' : floatValue;
                                setRangeFilterDraft((prev) => ({ ...prev, [startKey]: normalized }));
                                scheduleDebouncedSearch(`range:${startKey}`, () => {
                                  setSearch({
                                    field: startKey,
                                    startRange: normalized,
                                  });
                                  setRangeFilterDraft((prev) => {
                                    const next = { ...prev };
                                    delete next[startKey];
                                    return next;
                                  });
                                });
                              }}
                            />
                          </Col>
                          <Col>
                            <NumericFormat
                              customInput={Input}
                              placeholder="Digite um valor"
                              decimalSeparator=","
                              thousandSeparator="."
                              decimalScale={2}
                              prefix="R$"
                              value={(() => {
                                const endKey = `end${getColumnRangeFilterField(column)}`;
                                if (Object.prototype.hasOwnProperty.call(rangeFilterDraft, endKey)) {
                                  return rangeFilterDraft[endKey];
                                }
                                return searchArray.find((s) => s.field === endKey)?.endRange || '';
                              })()}
                              fixedDecimalScale
                              valueIsNumericString
                              onValueChange={({ floatValue }) => {
                                const rf = getColumnRangeFilterField(column);
                                const endKey = `end${rf}`;
                                const normalized = floatValue === undefined || floatValue === null ? '' : floatValue;
                                setRangeFilterDraft((prev) => ({ ...prev, [endKey]: normalized }));
                                scheduleDebouncedSearch(`range:${endKey}`, () => {
                                  setSearch({
                                    field: endKey,
                                    endRange: normalized,
                                  });
                                  setRangeFilterDraft((prev) => {
                                    const next = { ...prev };
                                    delete next[endKey];
                                    return next;
                                  });
                                });
                              }}
                            />
                          </Col>
                        </Row>
                      </PopoverBody>
                    </UncontrolledPopover>
                  </div>
                </Col>
              </Row>
            ) : null}
          </th>
        ))}
      </tr>
    </thead>
  ), [
    visibleColumns,
    searchArray,
    textFilterDraft,
    rangeFilterDraft,
    clearFilter,
    clearRangeFilter,
    getColumnRangeFilterField,
    getColumnTextFilterField,
    setSearch,
    scheduleDebouncedSearch,
  ]);

  const colSpanSafe = useMemo(() => Math.max(visibleColumns.length, 1), [visibleColumns.length]);

  if (loading) {
    return (
      <Table responsive className="custom-table">
        {renderHeader()}
        <tbody>
          <tr>
            <td colSpan={colSpanSafe} className="text-center p-4">
              <div className="d-flex justify-content-start align-items-center">
                <div className="spinner-border text-primary mr-2" role="status" />
                <span className="text-primary">Carregando...</span>
              </div>
            </td>
          </tr>
        </tbody>
      </Table>
    );
  }

  return (
    <>
      <Table responsive className="custom-table">
        {renderHeader()}
        <tbody>
          {data.map((row, index) => (
            <tr key={`${row._id}-${index}`} onClick={() => onRowClick(row)}>
              {visibleColumns.length ? visibleColumns.map((column) => {
                const rawValue = column.formatter ? column.formatter(row) : row[column.dataField];
                const displayValue = typeof rawValue === 'string'
                  ? rawValue.toString().trim().toUpperCase()
                  : rawValue;

                return (
                  <td
                    key={column.dataField}
                    className={`p-2 ${column.tdClassName || ''}`}
                    style={{
                      width: column.width || 'auto',
                      minWidth: column.minWidth || 'auto',
                      maxWidth: column.maxWidth || 'none',
                      whiteSpace: column.nowrap === false ? 'normal' : 'nowrap',
                      overflow: column.ellipsis ? 'hidden' : 'visible',
                      textOverflow: column.ellipsis ? 'ellipsis' : 'clip',
                    }}
                    title={typeof rawValue === 'string' ? rawValue : undefined}
                  >
                    {displayValue}
                  </td>
                );
              }) : (
                <td colSpan={colSpanSafe} className="p-2 text-center">
                  Nenhuma coluna selecionada
                </td>
              )}
            </tr>
          ))}
        </tbody>
        {paging ? (
          <tfoot>
            <tr>
              <td colSpan={colSpanSafe}>
                <Row>
                  <Col xs={12} tag="div" className="d-flex flex-wrap justify-content-center align-items-center justify-content-sm-end h-100">
                    <div className="text-right mr-2 mb-2">
                      {`Total de documento(s) ${page * limit > totalDocs ? totalDocs : page * limit}/${totalDocs}`}
                    </div>
                    <Pagination
                      page={page}
                      hasNextPage={hasNextPage}
                      hasPrevPage={hasPrevPage}
                      totalPages={totalPages}
                      onPageChange={onChangePage}
                    />
                  </Col>
                </Row>
              </td>
            </tr>
          </tfoot>
        ) : (
          <tfoot>
            <tr>
              <td colSpan={colSpanSafe}>
                <Row>
                  <Col xs={12} tag="div" className="d-flex flex-wrap justify-content-center align-items-center justify-content-sm-end h-100">
                    <div className="text-right mr-2 mb-2">
                      {`Total de documento(s) ${totalDocs}`}
                    </div>
                  </Col>
                </Row>
              </td>
            </tr>
          </tfoot>
        )}
      </Table>

      {selectableColumns && (
        <Modal
          isOpen={showSelectColumns}
          centered
          toggle={() => setShowSelectColumns(false)}
        >
          <ModalHeader>
            <strong>Seleciona as colunas que deseja exibir na tabela</strong>
            <Button
              className="close position-absolute top-4 right-4 py-1 px-2"
              onClick={() => setShowSelectColumns(false)}
            >
              <i className="fas fa-times" />
            </Button>
          </ModalHeader>
          <ModalBody>
            {columns.map((column) => (
              <FormGroup key={column.id || column.dataField} check>
                <Input
                  type="checkbox"
                  checked={selectedColumns.some((c) => c.dataField === column.dataField)}
                  disabled={!!column.alwaysVisible}
                  onChange={() => toggleColumn(column)}
                />
                <Label check>{column.text}</Label>
              </FormGroup>
            ))}
          </ModalBody>
          <ModalFooter tag="div" className="d-flex justify-content-between">
            <div>
              {selectedColumns.length !== columns.length && (
                <Button color="primary" className="mr-2" onClick={restoreColumns}>
                  Restaurar
                </Button>
              )}
              <Button color="warning" onClick={clearColumns}>
                Limpar
              </Button>
            </div>
            <div>
              <Button color="danger" onClick={() => setShowSelectColumns(false)}>
                Fechar
              </Button>
            </div>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
});

export default CustomTable;
